import { render, staticRenderFns } from "./AulaSearch.vue?vue&type=template&id=dc8791e2&scoped=true&"
import script from "./AulaSearch.vue?vue&type=script&lang=js&"
export * from "./AulaSearch.vue?vue&type=script&lang=js&"
import style0 from "./AulaSearch.vue?vue&type=style&index=0&id=dc8791e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8791e2",
  null
  
)

export default component.exports